import { useRef, useEffect } from 'react';
import { useQuery } from 'hooks/useCustomQuery';
import getAllNumbersList from 'API/Numbers/getAllNumbersList';

const useGetNumbers = (
    currentScope,
    currentWholesaler,
    currentPartner,
    currentCompany,
    setTableData,
    setSummaryData,
    platformList,
    hasPlatformSelected,
) => {
    const setTableDataRef = useRef(setTableData);
    setTableDataRef.current = setTableData;

    const setSummaryDataRef = useRef(setSummaryData);
    setSummaryDataRef.current = setSummaryData;

    const query = useQuery({
        queryKey: ['numbers', currentScope],
        queryFn: () =>
            getAllNumbersList(
                currentScope,
                currentWholesaler,
                currentPartner,
                currentCompany,
            ),
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled:
            platformList !== undefined &&
            platformList?.length !== 1 &&
            !hasPlatformSelected,
    });

    useEffect(() => {
        if (!query.data) return;
        setTableDataRef.current((prev) => ({
            ...prev,
            data: query.data.numbers || [],
        }));
    }, [query.data]);

    // The summary is shared with the platform numbers query, so it is only
    // written while the general numbers list is the view being shown. Keyed off
    // hasPlatformSelected as well as the data so switching back from the
    // platform view restores these counts even when the refetch returns an
    // identical payload (React Query keeps the same data reference).
    useEffect(() => {
        if (!query.data || hasPlatformSelected) return;
        const numbersList = query.data.numbers || [];
        setSummaryDataRef.current((prev) => ({
            ...prev,
            numbers: numbersList.length,
            activePlatformNumbers: query.data.activePlatformNumbers,
            disabledPlatformNumbers: query.data.disabledPlatformNumbers,
            pendingPlatformNumbers: query.data.pendingPlatformNumbers,
        }));
    }, [query.data, hasPlatformSelected]);

    return query;
};

export default useGetNumbers;
